import type { FC } from "react";
import { useSelector } from "react-redux";
import { InfoPage } from "senf-atomic-design-system";
import useHandles from "../hooks/hooks";
import type { ClientState } from "../redux/reducers/dataReducer";

const ProjectInfoPage: FC = () => {
  const project = useSelector((state: ClientState) => state.data.project);
  const handle = useHandles(project.projectId, null, null);

  return (
    <InfoPage
      // mode="view"
      project={project}
      handle={handle}
      variant="mainApp"
      className="h-screen w-screen"
    />
  );
};

export default ProjectInfoPage;
